"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FreightPieceType = exports.FreightType = void 0;
var FreightType;
(function (FreightType) {
    FreightType["Box"] = "Box";
    FreightType["Pallet"] = "Pallet";
    FreightType["LooseItem"] = "LooseItem";
    FreightType["Container"] = "Container";
    FreightType["Crate"] = "Crate";
})(FreightType = exports.FreightType || (exports.FreightType = {}));
var FreightPieceType;
(function (FreightPieceType) {
    FreightPieceType["Bag"] = "BG";
    FreightPieceType["Barrel"] = "BA";
    FreightPieceType["Bolt"] = "BT";
    FreightPieceType["Box"] = "BOX";
    FreightPieceType["Canister"] = "CI";
    FreightPieceType["Carton"] = "CT";
    FreightPieceType["Case"] = "CS";
    FreightPieceType["Container"] = "CON";
    FreightPieceType["Crate"] = "CR";
    FreightPieceType["Cylinder"] = "CY";
    FreightPieceType["Pieces"] = "PCS";
    FreightPieceType["Roll"] = "ROL";
    FreightPieceType["Tube"] = "TU";
})(FreightPieceType = exports.FreightPieceType || (exports.FreightPieceType = {}));
//# sourceMappingURL=freight.js.map